var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoServe4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 132,
    viewBox: "0 0 295 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 118.708L295 132C293.773 101.361 294.542 27.2954 294.08 19.536C293.619 11.8086 284.415 0.883621 273.37 0.82753C193.292 0.420822 30.4503 -0.811493 20.2496 0.82753C10.1248 2.45435 1.84088 13.0287 0 18.3159V131.083L18.5 115.958C18.6534 88.9801 18.381 28.2241 18.869 25.6367C19.3292 23.1964 23.3177 19.6716 25.7722 18.3159C103.703 18.3159 261.142 17.948 267.387 18.3159C274.29 18.7226 276.131 24.281 276.591 27.2635L279.5 118.708Z",
    fill: "#1D7F50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoServe4);
export default __webpack_public_path__ + "static/media/who_serve_4.959477d525c02e85d44ae837aef36ec3.svg";
export { ForwardRef as ReactComponent };